module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('router-link', {
    staticClass: "fl-button",
    attrs: {
      "to": {
        path: '/controller/edit/'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('h1', [_vm._v("Kontrollerek")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('inputbox', {
    attrs: {
      "id": "name",
      "label": "Megnevezés",
      "id": "name",
      "name": "name"
    },
    on: {
      "keydownEnter": _vm.searchClick
    },
    model: {
      value: (_vm.search.name),
      callback: function($$v) {
        _vm.$set(_vm.search, "name", $$v)
      },
      expression: "search.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "building_id",
      "label": "Épület",
      "name": "building_id",
      "options": _vm.buildings,
      "change": _vm.buildingChange
    },
    model: {
      value: (_vm.search.building_id),
      callback: function($$v) {
        _vm.$set(_vm.search, "building_id", $$v)
      },
      expression: "search.building_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "building_level_id",
      "label": "Épület szint",
      "name": "building_level_id",
      "options": _vm.building_levels
    },
    model: {
      value: (_vm.search.building_level_id),
      callback: function($$v) {
        _vm.$set(_vm.search, "building_level_id", $$v)
      },
      expression: "search.building_level_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "controller_type_id",
      "label": "Kontroller típus",
      "name": "controller_type_id",
      "options": _vm.controller_types
    },
    model: {
      value: (_vm.search.controller_type_id),
      callback: function($$v) {
        _vm.$set(_vm.search, "controller_type_id", $$v)
      },
      expression: "search.controller_type_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('button', {
    staticClass: "button with-icon",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchClick
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("Keresés")])])]), _vm._v(" "), (_vm.controllers.length > 0) ? _c('div', {
    staticClass: "table-with-title"
  }, [_c('h2', [_vm._v("Kontrollerek")]), _vm._v(" "), _c('table', {
    staticClass: "list"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.controllers), function(controller) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(controller.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(controller.alias))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(controller.building))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(controller.building_level))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(controller.x_coord) + ", " + _vm._s(controller.y_coord))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(controller.serial_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(controller.controller_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(controller.connection))]), _vm._v(" "), _c('td', {
      staticClass: "buttons"
    }, [_c('router-link', {
      staticClass: "small-button",
      attrs: {
        "to": {
          path: '/controller/edit/',
          query: {
            controllerID: controller.element_id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-alt"
    })]), _vm._v(" "), _c('a', {
      staticClass: "small-button",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.del(controller.element_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-alt"
    })]), _vm._v(" "), _c('ul', {
      staticClass: "small-buttons"
    }, [_c('li', [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "small-button-menu"
    }, [_c('div', {
      staticClass: "head"
    }, [_vm._v("Opciók")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.controllerOperation(controller.element_id, 'KONTROLLER_RESET', 'Reseteli a kontrollert?')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sync icon"
    }), _vm._v("Reset")])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.controllerDevicesReset(controller.element_id, controller.serial_number, 'hard')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sync icon"
    }), _vm._v("Eszköz reset (hard)")])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.controllerUploadCards(controller.element_id, controller.serial_number)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-upload icon"
    }), _vm._v("Kártyák feltöltése")])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.controllerDeleteCards(controller.element_id, controller.serial_number)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eraser icon"
    }), _vm._v("Kártyák törlése a kontrollerről")])])])])])])], 1)])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.controllers.length > 0) ? _c('pagination', {
    attrs: {
      "showcombo": "1",
      "limit": _vm.search.limit,
      "amount": _vm.search.amount
    },
    on: {
      "pageChanged": _vm.pageChanged
    },
    model: {
      value: (_vm.search.page),
      callback: function($$v) {
        _vm.$set(_vm.search, "page", $$v)
      },
      expression: "search.page"
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('HTMLFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_vm._v("Kereső")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Megnevezés")]), _vm._v(" "), _c('th', [_vm._v("Alias")]), _vm._v(" "), _c('th', [_vm._v("Épület")]), _vm._v(" "), _c('th', [_vm._v("Épület szint")]), _vm._v(" "), _c('th', [_vm._v("Koordináta")]), _vm._v(" "), _c('th', [_vm._v("Serial szám")]), _vm._v(" "), _c('th', [_vm._v("Típus")]), _vm._v(" "), _c('th', [_vm._v("Connection")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "small-button with-menu",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-643c958a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/controllers.vue
// module id = 309
// module chunks = 0